import React, { useState } from 'react';
import Media from '../../Media/Media';
import Asset, { getAssetFilePath } from '../../Asset/Asset';
import { useSelector, shallowEqual } from 'react-redux';
import Instruction from '../Instruction/Instruction';
import './Mbar.scss';

const Mbar = props => {
  const { buttons, instructions, type, config } = props;
  const [activeButton, setActiveButton] = useState(0);
  const { dataUrl, assetManifest } = useSelector(
    state => ({
      dataUrl: state.BlockState.dataUrl,
      assetManifest: state.BlockState.assetManifest
    }),
    shallowEqual
  );
  const isRTL =
    document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl'
      ? true
      : false;
  const handleTabKeydown = (e, tabs, activeTab) => {
    // check for left arrow press
    if (e.keyCode === 37) {
      if (!isRTL) {
        // if we're on the first tab, focus the last tab
        if (activeTab === 0) {
          document.getElementById(`${tabs[tabs.length - 1].title}-tab`).focus();
        }
        // if we're not on the first tab, focus the previous tab
        if (activeTab !== 0) {
          document.getElementById(`${tabs[activeTab - 1].title}-tab`).focus();
        }
      }
      if (isRTL) {
        // if we're not on the last tab, focus the next tab
        if (activeTab < tabs.length - 1) {
          document.getElementById(`${tabs[activeTab + 1].title}-tab`).focus();
        }
        // if we're on the last tab, focus the first tab
        if (activeTab === tabs.length - 1) {
          document.getElementById(`${tabs[0].title}-tab`).focus();
        }
      }
    }
    // check for right arrow press
    if (e.keyCode === 39) {
      if (!isRTL) {
        // if we're not on the last tab, focus the next tab
        if (activeTab < tabs.length - 1) {
          document.getElementById(`${tabs[activeTab + 1].title}-tab`).focus();
        }
        // if we're on the last tab, focus the first tab
        if (activeTab === tabs.length - 1) {
          document.getElementById(`${tabs[0].title}-tab`).focus();
        }
      }
      if (isRTL) {
        // if we're on the first tab, focus the last tab
        if (activeTab === 0) {
          document.getElementById(`${tabs[tabs.length - 1].title}-tab`).focus();
        }
        // if we're not on the first tab, focus the previous tab
        if (activeTab !== 0) {
          document.getElementById(`${tabs[activeTab - 1].title}-tab`).focus();
        }
      }
    }
  };
  const handleNextButton = () => {
    if (activeButton < buttons.length - 1) {
      setActiveButton(activeButton + 1);
      scrollToTop();
    } else {
      setActiveButton(0);
      scrollToTop();
    }
  };
  const handlePreviousButton = () => {
    if (activeButton === 0) {
      setActiveButton(buttons.length - 1);
      scrollToTop();
    } else {
      setActiveButton(activeButton - 1);
      scrollToTop();
    }
  };
  const handleDotButton = index => {
    setActiveButton(index);
    scrollToTop();
  };
  const scrollToTop = () => {
    let tabControlPosition = document
      .getElementById(`${props.id}-buttons-wrapper`)
      .getBoundingClientRect().y;
    window.scroll({
      top: window.pageYOffset - -tabControlPosition - 100,
      behavior: 'smooth'
    });
  };
  return (
    <>
      <div
        className={`mbar-instructions${
          config.vertical === true ? ' isVertical' : ''
        }`}
        config={config}
      >
        {instructions && <Instruction id={instructions} simple={false} />}
      </div>
      <div role="tablist">
        <div
          style={{
            display: 'flex',
            flexDirection: config.vertical === true ? 'row' : 'column'
          }}
        >
          <div
            className={`mbar-buttons-wrapper${
              config.vertical !== undefined
                ? config.vertical === true
                  ? ' isVertical'
                  : ''
                : ''
            }${type === 'thumbnail' ? ' isThumbnail' : ''}`}
            type={type}
            id={`${props.id}-buttons-wrapper`}
            config={config}
          >
            {buttons.map((button, index) => (
              <button
                type="button"
                id={`${button.title}-tab`}
                role="tab"
                aria-controls={`${button.title}-panel`}
                aria-selected={index === activeButton}
                tabIndex={index === activeButton ? 0 : -1}
                key={index}
                className={`mbar-button ${index === activeButton && 'active'} ${
                  type === 'text' ? 'as-button' : 'as-thumbnail'
                } ${type === undefined ? 'as-button' : ''}${
                  config.vertical === true ? ' isVertical' : ''
                }`}
                onClick={() => setActiveButton(index)}
                onKeyDown={e => handleTabKeydown(e, buttons, index)}
                config={config}
              >
                {button.image && type === 'thumbnail' && (
                  <div
                    className="img"
                    style={{
                      backgroundPosition: 'center',
                      backgroundImage: `url("${getAssetFilePath(
                        button.image,
                        dataUrl,
                        assetManifest.assets
                      )}")`
                    }}
                  />
                )}
                <div type={type}>
                  <Asset
                    md={false}
                    id={button.title}
                    className="button-label"
                  />
                </div>
              </button>
            ))}
          </div>
          {buttons.map(
            (button, index) =>
              index === activeButton && (
                <div
                  id={`${button.title}-panel`}
                  className={`mbar-content-wrapper${
                    index === activeButton ? ' isVisible' : ' isHidden'
                  }${config['single-column'] ? ' single-column' : ''}`}
                  activebutton={activeButton}
                  button={index}
                  key={index}
                  config={config}
                  type={type}
                  role="tabpanel"
                  aria-labelledby={`${button.title}-tab`}
                  aria-hidden={index !== activeButton}
                  tabIndex={index === activeButton ? 0 : -1}
                >
                  {Object.keys(button).map((k, i) => {
                    if (k === 'content') {
                      return (
                        <div key={i} className="mbar-column mbar-content">
                          {button.content && <Asset id={button.content} />}
                        </div>
                      );
                    }
                    if (k === 'media' || k === 'image') {
                      return (
                        <div key={i} className="mbar-column">
                          <>
                            {button.image && !button.media && (
                              <Asset id={button.image} />
                            )}
                            {button.media && <Media use={button.media} />}
                          </>
                        </div>
                      );
                    }
                    return false;
                  })}
                </div>
              )
          )}
        </div>
        <div className="mbar-carousel-wrapper" aria-hidden="true">
          <div className="carousel">
            <div className="carousel__controls">
              <div
                onClick={() => handlePreviousButton()}
                className="btn btn--icon btn--small btn--primary-ghost back"
              >
                <span className="icon-chevron-left"></span>
              </div>
              {buttons.map((buttons, index) => (
                <div
                  key={index}
                  onClick={() => handleDotButton(index)}
                  className={`dot ${index === activeButton ? 'active' : ''}`}
                >
                  <span className="icon-circle"></span>
                </div>
              ))}
              <div
                onClick={() => handleNextButton()}
                className="btn btn--icon btn--small btn--primary-ghost next"
              >
                <span className="icon-chevron-right"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mbar;
